export function formatChartTick(v: string): string {
  const parts = v.split(':')
  const h = parseInt(parts[0], 10)
  return h % 3 === 0 && parts[1] === '00' ? v : ''
}
